module.exports = __webpack_public_path__ + "img/169.8b8879fa.jpg";